import { createCustomClasses, EXPAND_CHILD, requestNextLayoutMinDelay } from "react-flexbox-layout";

// eslint-disable-next-line @web-monorepo/no-css-file-imports
import "react-flexbox-layout/lib/styles.css";

const { HLayout, HLayoutItem, VLayout, VLayoutItem } = createCustomClasses({
  defaultGutter: 1,
  gutterMultiplier: 16,
  defaultGutterUnit: "px",
});

export { HLayout, HLayoutItem, VLayout, VLayoutItem, createCustomClasses, EXPAND_CHILD, requestNextLayoutMinDelay };
